import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import RouteManager from '../../managers/RouteManager';
import { fetchCustomFIelds, selectCustomField } from '../../Redux/Slices/CustomeFieldSlice';
import { CustomFieldColumnConfig, parseColumnConfig } from '../configs/config';
import { showAlert, showToast,showLoader, removeLoader, TOAST_TYPE } from 'deskera-ui-library';
import { COLUMN_CODE, TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";

import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from '../../utility/Utility';
import CustomFieldService from '../../services/CustomFieldService';
import DataGridHolderPayroll from '../common/DataGridHolderPayroll';
import Table from '../../services/table';
import AddCustomFieldPopUp from './AddCustomFieldPopUp';
import ReadWatchComponent from '../common/ReadWatchComponent';
import AppManager from '../../managers/AppManager';
import { getFileNameFromContentDisposition } from '../../managers/common/CommonUtil';
import { saveAs } from 'file-saver';
import PermissionUtils, { ACTION, MODULE } from '../user-permissions/PermissionUtils';

const CustomFieldsList = (props) => {
    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };

    const [customField, setCustomField] = useState(initialState);
    const [refresh, setRefresh] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(10);
    const [showList, setFiltersList] = useState(true);
    const [initialValue, setFilterInitialValue] = useState(0);
    const [showAddCustomField, setShowAddCustomField] = useState(false);


    const dispatch = useDispatch();
    const CustomFieldsData = useSelector(selectCustomField);
    const isActionEnabled = true;

    const [exportButtonTitle, setExportButtonTitle] = useState("Export Custom Fields");
    const [reload, setReload] = useState(false);

    useEffect(() => {
        RouteManager.setPresenter({ props });
        /* API Calls Start */
        loadCustomFields({});
        /* API Calls End */
        return () => setCustomField(initialState);
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(CustomFieldsData)) {
            const customFields = CustomFieldsData.customFields;
            const filterResponse = CustomFieldsData.filterConfig;
            const rowData = CustomFieldColumnConfig(customFields);
            let customFieldColumn = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.CUSTOME_FIELD_LIST),TABLES.CUSTOME_FIELD_LIST)
            const passingData = {
                columnData: deepClone(customFieldColumn),
                rowData,
                filter: [],
                originalData: customFields
            };
            const isFilterListEnabled = CustomFieldsData.length > 0 ? true : false;
            setCustomField(passingData);
            setTotalPageCount(filterResponse.totalPage);
            setCurrentPage(+filterResponse?.page);
            setTotalCount(filterResponse.sizePerPage)
            setFiltersList(isFilterListEnabled);
            setFilterInitialValue(0);
        }
    }, [CustomFieldsData,reload]);


    const loadCustomFields = async (config) => {
        try {
            CustomFieldService.apiConfig = config;
            const timeout = showDelayedLoader();
            await dispatch(fetchCustomFIelds());
            removeDelayedLoader(timeout);
        } catch (err) {
            console.error('Error loading custom fields: ', err);
        }
    };


    const addCustomFields = (row) => {
        // props.setData({
        //     onCancel: onClose,
        // });
        setShowAddCustomField(true)
    }

    const deleteConfirm = (data) => [
        {
            title: "Cancel",
            className: "bg-gray1 border-m",
            
        },
        {
            title: "Delete",
            className: "bg-red text-white ml-r",
            onClick: () => onRowDelete(data, true),
        },
    ];

    const onRowDelete = (data, isForceDelete) => {

        const customFieldId = data.rowData.id;
        let params = {
            ids: [customFieldId],
            forcedDelete : isForceDelete
        }
        try {
            Table.deleteCustomFields(params).then((response) => {
                if(response.errCode === "CF_1003"){
                    const modules = data?.rowData?.mappedWith;
                    const buttons = [
                        {
                          title: "Ok",
                          className: "bg-red text-white ml-r"
                        },
                      ];
                    showAlert(
                        "Custom field is already in use in some of the below modules so cannot be deleted!",
                        `<div class=''>${modules.map((f,i) => `<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:5px'><div class='fs-m cursor-hand'><span class='fw-m'>${i + 1}.</span> <span class='text-app'>${getFieldName(f)}</span></div></div>`).join('')}</div>`,
                        buttons
                      );
                } else {
                    showToast("Custom field deleted successfully", TOAST_TYPE.SUCCESS);
                    loadCustomFields({})
                }
            })
        } catch (err) {
            
            showToast('Error deleting custom field : ', TOAST_TYPE.FAILURE);
        }

    }

    const onClose = () => {
        setShowAddCustomField(false)
    }

    const getFieldName = (f) => {
        switch (f) {
            case "employee_details":
                return "Employee Details"
            case "payrun":
                return "Payruns"
            case "payschedule":
                return "Payschedules";
            case "compOff":
                return "Compensatory Off";    
            default:
                break;
        }
    }

    const onSort = (data) => {
        if (data) {
            loadCustomFields({
                ...CustomFieldService.apiConfig,
                Order: data.order.toLowerCase(),
                Field: data.columnData.columnCode
            });
        }
    }
    const onRowEdit = (data) => {
        if(data) {
            setShowAddCustomField(data.rowData)
        }
    }

    const onRowUpdate = (data) => {
        if(data) {
            switch(data.columnKey) {
                case COLUMN_CODE.CUSTOM_FIELD_LIST.STATUS:
                    let dataToUpdate = deepClone(data.rowData);
                    dataToUpdate['isActive'] = dataToUpdate['status'][0] === 'true' ? true : false; 
                    updateCustomField(dataToUpdate)
                break;
            }
            
        }
    }
    const updateCustomField = (payload) => {

        delete payload.error;
        delete payload.displayIn;
        delete payload.selected;
        delete payload.preference;
        delete payload.status;

        showLoader(`Updating custom field`);
        Table.updateCustomField(payload).then((data) => {
            removeLoader()
            if (data?.error && data.error.errorCode === "CF_1001") {
                showToast('Custom field default value exceeds the maxlength ', TOAST_TYPE.FAILURE);
                return
            }

            if (data?.error && data.error.errorCode === "CF_1004") {
                showToast(data.error.details, TOAST_TYPE.FAILURE);
                return
            }

            showToast("Record updated Successfully", TOAST_TYPE.SUCCESS);
            loadCustomFields({
                ...CustomFieldService.apiConfig
            });
            
        }, error => {
            removeLoader()
            showToast('Error while updating custom field ', TOAST_TYPE.FAILURE);
        })
    }

    const exportCustomFields = () => {
        setExportButtonTitle("Exporting...");
        CustomFieldService.exportCustomFields().then(
            (response) => {
                const headers = response['headers'];
                const filename = getFileNameFromContentDisposition(headers['content-disposition']);
                saveAs(response.data, filename);
                setExportButtonTitle("Export Custom Fields");
                showToast("Custom fields exported successfully", TOAST_TYPE.SUCCESS);
            }, (error) => {
                setExportButtonTitle("Export Custom Fields");
                showToast("Something went wrong", TOAST_TYPE.FAILURE);
            }
        );
    }

    return (
        <>
            <ReadWatchComponent
                title="Need help getting started? Learn more about creating Custom Field."
                onRead={AppManager.showComingSoonWarning}
                onWatch={AppManager.showComingSoonWarning}
                exportTitle={"Manage your Custom Fields."}
                export={exportButtonTitle}
                onExportClick={exportCustomFields}
            />
        <div className="column parent-width flex-1 parent-height">
            <div className="column parent-width mb-s position-relative flex-1 ">
                
                <DataGridHolderPayroll
                    tableName={TABLES.CUSTOME_FIELD_LIST}
                    displayTableName={TABLE_DISPLAY_NAME[TABLES.CUSTOME_FIELD_LIST]}
                    allowRowEdit={PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS,[ACTION.EDIT])}
                    allowColumnEdit={false}
                    allowRowAdd={true}
                    allowColumnAdd={false}
                    allowColumnDelete={true}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    onRowDelete={onRowDelete}
                    onRowEdit={(data) => {
                        onRowEdit(data);
                    }}
                    onRowUpdate={onRowUpdate}
                    refresh={refresh}
                    addButtonConfig={[{
                        title: "+ Add Custom Field",
                        className: "bg-app text-white",
                        onClick: () => addCustomFields(),
                    }]}
                    allowDataExport={true}
                    gridData={customField}
                    //   onSearch={onSearch}
                    //   onColumnAdd={newColumnAdded}
                    //   onFilter={onFilter}
                    filter={CustomFieldsList.filter}
                    onPaginationClick={(requestedPageNumber) => {
                        const config = {
                            ...CustomFieldService.apiConfig,
                            CurrentPage: requestedPageNumber, // Books backend pagination offset is 0, so subtract 1
                        };
                        loadCustomFields(config);
                    }}
                    currentPage={currentPage}
                    totalPageCount={totalPageCount}
                    isActionEnabled={isActionEnabled}
                    contextMenu={true}
                    onSort={(data) => onSort(data)}
                    onColumnShift={(data)=> setReload(!reload)}
                    module={MODULE.COMPANY_SETTINGS}
                    
                />
                {showAddCustomField && (
                    <div className="transparent-background">
                        <AddCustomFieldPopUp
                            onClose={() => onClose()}
                            customFieldData={showAddCustomField}
                            loadCustomFields={() => loadCustomFields()}
                        />
                    </div>
                )}
            </div>
        </div>
        </>
    )
}

export default CustomFieldsList
